// import { tr } from "date-fns/locale";

export const updateStartDate = (dateFrom) => {
  if (dateFrom) {
    dateFrom.setHours(0);
    dateFrom.setMinutes(0);
    dateFrom.setSeconds(0);
  }

  return dateFrom;
};

export const updateEndDate = (dateTo) => {
  if (dateTo) {
    dateTo.setHours(23);
    dateTo.setMinutes(59);
    dateTo.setSeconds(59);
  }

  return dateTo;
};

export const validateDateRange = (startDateInput, endDateInput) => {
  // 1. Convert inputs to Date objects for reliable comparison
  const startDate = new Date(startDateInput);
  const endDate = new Date(endDateInput);

  // 2. Initial validation: check if the dates are valid (Date objects return 'Invalid Date' if parsing fails)
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
    return false;
  }

  // 3. Compare the dates: start date must be less than or equal to the end date
  if (startDate <= endDate) {
    return true;
  }
  // This covers the "vice versa" scenario where end date is before start date
  return false;
};
